export enum ActionResult {
    SUCCESS = "SUCCESS",
    FAILED = "FAILED"
}

export interface IGenericWorkflowActionResult {
    result: ActionResult,
    data: any,
    error: any
}